import { mergeStyleSets } from "@fluentui/react";
import { IEmbedSettings, models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import React, { useEffect } from "react";

import { usePowerBiReport } from "../usePowerBiReport";

export interface PowerBIReportProps {
    settings?: IEmbedSettings;
    filters?: models.ReportLevelFilters[];
}

const styles = mergeStyleSets({
    pbiEmbedContainer: { height: "100%", selectors: { iframe: { border: 0, height: "100%", display: "flex" } } }
});

export const PowerBIReport = (props: PowerBIReportProps): JSX.Element => {
    const { reportConfig, setConfig, getReport } = usePowerBiReport(props);

    useEffect(() => {
        getReport().then((response) => setConfig(response));
    }, []);

    if (!reportConfig.embedUrl || !reportConfig.accessToken) {
        return <></>;
    }

    return <PowerBIEmbed embedConfig={reportConfig} cssClassName={styles.pbiEmbedContainer} />;
};
